import React from "react";
import '@fortawesome/fontawesome-free/css/all.min.css'; // Correct import
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Generally used for icons
import { faMoneyBillWave } from "@fortawesome/free-solid-svg-icons"; // Not used in current code

const PlanCards = () => {
  return (
    <div className="row">
      <div className="col-md-4 mb-4">
        <div className="card border-left-success shadow h-100 py-2">
          <div className="card-body">
            <div className="row no-gutters align-items-center">
              <div className="col mr-2">
                <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                  Plan A
                </div>
                <div className="h5 mb-0 font-weight-bold text-gray-800">
                  $215,000
                </div>
              </div>
              <div className="col-auto">
                <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 mb-4">
        <div className="card border-left-success shadow h-100 py-2">
          <div className="card-body">
            <div className="row no-gutters align-items-center">
              <div className="col mr-2">
                <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                  Plan B
                </div>
                <div className="h5 mb-0 font-weight-bold text-gray-800">
                  $450,200
                </div>
              </div>
              <div className="col-auto">
                <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 mb-4">
        <div className="card border-left-success h-100 py-2">
          <div className="card-body">
            <div className="row no-gutters align-items-center">
              <div className="col mr-2">
                <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                  Plan C
                </div>
                <div className="h5 mb-0 font-weight-bold text-gray-800">
                  $230,000
                </div>
              </div>
              <div className="col-auto">
              <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanCards;